import React from 'react'
import './TeambuildingsPage.css'
import Header from '../components/Header'
import Footer from '../components/Footer'

function TeambuildingsPage() {
  return (
    <div className="page_container" id="teambuildings-page">
      <section className="page_section" id="hero-section">
        <Header />
        <div className="sub_section title_section">
          <h1>Teambuildings <br /> Workshops <br /> Zaalverhuur</h1>
        </div>
      </section>

      <section className="page_section" id="teambuildings-content">
        <div className="content_box">
          <div className="service-section">
            <h2>Paaldansworkshop voor Bedrijven</h2>
            <h3>Ervaar een unieke teambuildingactiviteit die bijblijft</h3>
            <p>
              Op zoek naar een verrassende manier om je team uit te dagen, te motiveren en verbinden? Of het nu gaat om een bedrijfsuitje, teamdag of creatieve break tijdens een offsite: deze workshop zorgt gegarandeerd voor energie, samenwerking en vooral veel plezier. Geen ervaring nodig – enkel een open mind en zin in iets nieuws!
            </p>

            <h4>Waarom kiezen voor een paaldansworkshop?</h4>
            <ul>
              <li><strong>Teambuilding met impact:</strong> Stap samen uit jullie comfortzone en ontdek nieuwe kanten van jezelf én je collega's.</li>
              <li><strong>Vertrouwen en verbinding:</strong> Samenwerken, lachen en elkaar aanmoedigen versterkt het groepsgevoel.</li>
              <li><strong>Fysiek én mentaal een boost:</strong> Paaldansen combineert kracht, coördinatie en fun in één complete workout.</li>
              <li><strong>Professionele begeleiding:</strong> Onze ervaren instructeurs zorgen voor een veilige, respectvolle en motiverende sfeer.</li>
            </ul>

            <h4>Wat kun je verwachten?</h4>
            <ul>
              <li>Geschikt voor alle leeftijden, achtergronden en fitnessniveaus</li>
              <li>Warming-up, basis spins & tricks, en een leuke choreografie</li>
              <li>Duur: 1 tot 1,5 uur (in overleg)</li>
              <li>In onze professionele dansstudio - State of the Art studio</li>
              <li>Ervaren instructeurs</li>
              <li>Kom in sportieve kledij, korte short</li>
              <li><strong>€30 per persoon</strong></li>
              <li>Gemakkelijk bereikbare locatie op de Pottelbergsite te Kortrijk, omringd door andere activiteiten combineerbaar bij jouw teambuilding</li>
              <li>Gratis parkeren, vlak voor de deur</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Paaldansworkshops voor Vrijgezellenfeesten & Groepen</h2>
            <h3>Dit is hoe je een vrijgezellenfeest onvergetelijk maakt.</h3>
            <p>
              Op zoek naar een originele en speelse activiteit voor een vrijgezellenactiviteit, verjaardagsfeest of uitstap met vrienden? Of jullie nu komen om een vrijgezel in het zonnetje te zetten, samen herinneringen te maken of gewoon een hilarisch leuke middag te beleven – deze workshop is een ervaring om nooit te vergeten. Ze biedt dé perfecte mix van lachen, uitdagen en vieren. Of jullie nu beginners zijn of al eens aan een paal hebben gehangen – iedereen is welkom!
            </p>

            <h4>Waarom kiezen voor een paaldansworkshop?</h4>
            <ul>
              <li><strong>Uniek groepsuitje:</strong> Iets compleet anders dan de standaard activiteiten – en zóveel leuker!</li>
              <li><strong>Boost voor zelfvertrouwen & fun:</strong> Lachen, bewegen en samen iets nieuws proberen in een veilige, positieve sfeer.</li>
              <li><strong>Geen ervaring nodig:</strong> Onze ervaren instructeurs begeleiden jullie stap voor stap – het draait om plezier, niet om perfectie.</li>
              <li>Gegarandeerd gespreksstof voor de rest van de dag (en avond).</li>
            </ul>

            <h4>Wat kun je verwachten?</h4>
            <ul>
              <li>Warm welkom in onze gezellige State of the Art Studio</li>
              <li>Toffe spins, basic tricks en een korte groepschoreografie</li>
              <li>Tijd voor foto's & filmpjes om het moment vast te leggen</li>
              <li>Workshopduur: 1 tot 1,5 uur, afhankelijk van jullie wensen en de groepgrootte</li>
              <li>Optioneel: thema's op aanvraag</li>
              <li>Kledij: sportieve kledij, korte short</li>
              <li><strong>Prijs: €30 per persoon</strong></li>
              <li>Gemakkelijk bereikbaar, ruime gratis parking voor de deur</li>
            </ul>
          </div>

          <div className="service-section">
            <h2>Zaalverhuur</h2>
            <h3>Huur onze stijlvolle danszaal in Kortrijk</h3>
            <h4>Licht, ruimte en comfort voor al je creatieve momenten</h4>
            <p>
              Ben je op zoek naar een dans- of oefenruimte in Kortrijk? Onze prachtige zaal is te huur voor danslessen, workshops, personal training, repetities, yoga, pilates, fotoshoots en andere creatieve projecten. Of je nu een eenmalige sessie organiseert of op zoek bent naar een vaste locatie: wij bieden flexibele huurmogelijkheden aan voor zowel particulieren als professionelen.
            </p>

            <h4>De zaal is licht, ruim en professioneel uitgerust:</h4>
            <ul>
              <li>Grote wandspiegels voor optimale zichtbaarheid tijdens het oefenen</li>
              <li>Veel natuurlijk daglicht én dimbare sfeerverlichting naar keuze</li>
              <li>Warme laminaatvloer – ideaal om op te dansen of bewegen</li>
              <li>Hoog plafond voor een open en luchtige sfeer</li>
              <li>Airconditioning voor aangename temperatuur, het hele jaar door</li>
              <li>Mooie inrichting met planten die zorgt voor een aangename sfeer</li>
              <li>Vlot bereikbaar en ruime parking</li>
              <li><strong>Ruim: zo'n 120 m²</strong></li>
              <li>Basic sportmaterialen zoals yogamatjes en yogablokken aanwezig</li>
            </ul>

            <h4>Interesse?</h4>
            <p>
              Neem gerust contact met ons op voor beschikbaarheid, tarieven of een bezichtiging. We verwelkomen je graag!
            </p>
          </div>

          <div className="contact-section">
            <h2>Contact & Boekingen</h2>
            <p>
              Voor meer informatie, beschikbaarheid of om een workshop of zaalverhuur te boeken, neem contact met ons op:
            </p>
            <p>
              <strong>E-mail:</strong> <a className="email-link" href="mailto:info@poledistrict85.be">info@poledistrict85.be</a><br />
              <strong>Adres:</strong> Engelse wandeling 2 K16V, 8500 Kortrijk
            </p>
            <p>
              We beantwoorden graag al je vragen en helpen je bij het plannen van een onvergetelijke ervaring!
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default TeambuildingsPage 